<template>
    <div class="proveedores">
        <MenuOpcion :titulo="titulo">            
            <!-- <template v-slot:content>
                <b-nav-form>
                    <b-form-input size="sm" class="mr-sm-2" placeholder="Reserva,Paquete,Cliente ..."></b-form-input>
                    <b-button size="sm" class="my-2 my-sm-0" type="submit">BUSCAR</b-button>
                </b-nav-form>                    
                <div class="float-right">
                    <b-btn 
                        variant="success"
                        v-b-tooltip.hover title="Actualizar"                         
                        @click="actualizarLista"
                    >@
                    </b-btn>                                        
                </div>
            </template> -->
        </MenuOpcion>
        
        <!-- <ListaReservas ref="listaR" class="mt-2" v-if="!reserva"/>
        <Reserva ref="reserva" class="mt-2" v-else/> -->

    </div>
</template>

<script>

import MenuOpcion from '@/components/MenuOpcion.vue'
// import ListaReservas from '@/components/ListaReservas.vue'
// import Reserva from '@/components/reserva.vue'


export default {
    name: 'proveedores',
    components: {
        MenuOpcion,
        //ListaReservas,Reserva,
    },

    data() {
        return {
            titulo: 'PROVEEDORES',
        }
    },

    created() {
        if (!this.$store.state.auth.logueado) this.$router.push('/');
    },

    computed: {
        reserva() {
            return this.$store.state.reserva.id;
        },
    },

    methods: {
        actualizarLista() {        
            //this.$refs.listaR.leemosReservas();
            ////this.$store.ListaReservas.leemosReservas();
        },  
        listado() {
            this.$store.state.reserva={id:0};
            this.actualizarLista();
        }
    },    
    
}
</script>